import { LoginPage } from './login.component';
import { connect } from 'react-redux';
import { userLogin, userGoogleLogin } from './../../api/user/userAction';

const mapDispatchToProps = {
    userLogin,
    userGoogleLogin
};

const mapStateToProps = state => ({
    isLoading: state.userPage.isLoading,
    isLoggedIn: state.userPage.isLoggedIn,
    loggedUser: state.userPage.loggedUser
});

export const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(LoginPage);